import React from 'react'

import { IRadarChartT2ForPrintingSectionProps } from './interface'
import { EReviewerTypes } from '../../interface'
import WrapperBlock from '../WrapperBlock'
import RadarChartT2ForPrinting from './RadarChartT2ForPrinting'
import { SUPERVISORS, PEERS, DIRECT, SELF, COLORS_OPACITY_08 } from '../../Reports'

import './styles.scss'
import { TYPE_OF_REVIEWERS } from 'app/constants/reviews'
const bc = 'radar-chart-t2-for-printing-section'

const RadarChartT2ForPrintingSection: React.FC<IRadarChartT2ForPrintingSectionProps> = ({ data, reviewers }) => {
  const superiors = reviewers[TYPE_OF_REVIEWERS.SUPERIOR]
  const peers = reviewers[TYPE_OF_REVIEWERS.PEER]
  const employees = reviewers[TYPE_OF_REVIEWERS.EMPLOYEE]
  console.log('__RadarChartT2ForPrintingSection__')
  return (
    <div className={bc}>
      <div className={`${bc}__row`}>
        <WrapperBlock style={{ borderTop: `8px solid ${COLORS_OPACITY_08[SELF]}` }}>
          <RadarChartT2ForPrinting
            // @ts-ignore
            data={data[EReviewerTypes.Self]}
            reviewer={EReviewerTypes.Self}
            subtitle={SELF}
          />
        </WrapperBlock>
        {!!superiors && (
          <WrapperBlock style={{ borderTop: `8px solid ${COLORS_OPACITY_08[SUPERVISORS]}` }}>
            <RadarChartT2ForPrinting
              // @ts-ignore
              data={data[EReviewerTypes.Supervisors]}
              reviewer={EReviewerTypes.Supervisors}
              subtitle={SUPERVISORS}
            />
          </WrapperBlock>
        )}
      </div>
      <div className={`${bc}__row`}>
        {!!peers && (
          <WrapperBlock style={{ borderTop: `8px solid ${COLORS_OPACITY_08[PEERS]}` }}>
            <RadarChartT2ForPrinting
              // @ts-ignore
              data={data[EReviewerTypes.Peers]}
              reviewer={EReviewerTypes.Peers}
              subtitle={PEERS}
            />
          </WrapperBlock>
        )}
        {!!employees && (
          <WrapperBlock style={{ borderTop: `8px solid ${COLORS_OPACITY_08[DIRECT]}` }}>
            <RadarChartT2ForPrinting
              // @ts-ignore
              data={data[EReviewerTypes.Direct]}
              reviewer={EReviewerTypes.Direct}
              subtitle={DIRECT}
            />
          </WrapperBlock>
        )}
      </div>
    </div>
  )
}

export default RadarChartT2ForPrintingSection
